import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionAuthLogoutPayload,
	IActionAuthLogoutPayloadDone,
	IActionAuthLogoutPayloadError,
} from './types';

export const authLogout = actionCreatorAsync<
	IActionAuthLogoutPayload,
	IActionAuthLogoutPayloadDone,
	IActionAuthLogoutPayloadError
>(
	'authLogout',
	async () => {
		const { data } = await Api.auth.logout();

		return data;
	},
);
